/* Cart Reward Progress — PARABAYA
   - Déplace la section sous la barre de livraison gratuite
   - Calcule le total du panier via /cart.js
   - Met à jour la barre, le message et l'état (reached)
*/

(function () {
  const SELECTOR_SECTION = '[id^="cart-reward-progress-"].crp-wrapper';
  const SELECTOR_DRAWER  = '.cart-drawer, [data-name="cart-drawer"]';
  const SELECTOR_FREEBAR = '.free-shipping-bar, .free-shipping, .free-shipping-bar__bar, .free-shipping__bar';

  function qs(a, b=document)  { return b.querySelector(a); }
  function qsa(a, b=document) { return Array.from(b.querySelectorAll(a)); }

  function moveIntoDrawer(section) {
    const drawer = qs(SELECTOR_DRAWER) || qs('#CartDrawer, .js-cart-drawer');
    if (!drawer) return;

    const freeBar = qs(SELECTOR_FREEBAR, drawer);
    if (freeBar && freeBar.parentNode) {
      freeBar.parentNode.insertAdjacentElement('afterend', section);
    } else {
      const footer = qs('.cart-drawer__footer, .cart-drawer__footer-container, .cart__footer', drawer);
      if (footer && footer.parentNode) {
        footer.parentNode.insertBefore(section, footer);
      } else {
        qs('.cart-drawer__content, .cart-drawer__content-item, .cart__items', drawer)?.appendChild(section);
      }
    }
    section.classList.add('crp-anim-enter');
    setTimeout(() => section.classList.remove('crp-anim-enter'), 150);
  }

  async function fetchCartTotalCents() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return null;
      const cart = await res.json();
      return cart.total_price ?? null; // cents
    } catch (_) {
      return null;
    }
  }

  // ————— Bind une seule fois le message "idle" pour y insérer <span class="crp-missing"> —————
  function bindIdleTemplate(section) {
    const idleP = qs('.crp-msg--idle', section);
    if (!idleP || idleP.dataset.bound === '1') return;

    // Source template: data-crp-idle-text (idéal) ou HTML actuel
    let tpl = section.dataset.crpIdleText || idleP.innerHTML || '%missing%€ restants pour obtenir votre Carte Cadeau.';

    // Assure qu'il y a <span class="crp-missing"> autour de %missing%
    if (tpl.includes('%missing%')) {
      tpl = tpl.replace('%missing%', '<span class="crp-missing">%missing%</span>');
    } else {
      // Pas de placeholder: on force un template stable "VAL € + le reste"
      const txt = idleP.textContent.trim();
      const rest = txt.replace(/^\s*\d+[.,]?\d*\s*€?\s*/,'').trim() || 'restants pour obtenir votre Carte Cadeau.';
      tpl = `<span class="crp-missing">%missing%</span>€ ${rest}`;
    }

    idleP.innerHTML = tpl;
    idleP.dataset.bound = '1';
  }

  function setIdleText(section, missingCents) {
    bindIdleTemplate(section); // garantit la présence du span
    const span = qs('.crp-msg--idle .crp-missing', section);
    if (!span) return;
    span.textContent = (missingCents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 0 });
    span.style.setProperty('font-weight', '700', 'important'); // au cas où le thème écrase
  }

  function setReachedText(section, rewardEUR) {
    const reachedP = section.querySelector('.crp-msg--reached');
    const tpl = section.dataset.crpReachedText || 'Votre carte cadeau de %reward%€ est débloquée 🎉';
    if (reachedP) reachedP.innerHTML = tpl.replace('%reward%', String(rewardEUR));
  }

  function refresh(section) {
    const thresholdCents = Number(section.dataset.crpThresholdCents || 0);
    const rewardEUR      = Number(section.dataset.crpRewardEur || 0);

    fetchCartTotalCents().then(totalCents => {
      if (totalCents == null) return;

      const ratio        = Math.max(0, Math.min(1, (thresholdCents ? totalCents / thresholdCents : 0)));
      const missingCents = Math.max(0, thresholdCents - totalCents);

      setIdleText(section, missingCents);
      setReachedText(section, rewardEUR);

      const fill = qs('.crp-bar-fill', section);
      if (fill) fill.style.width = (ratio * 100).toFixed(2) + '%';

      section.classList.toggle('crp-reached', ratio >= 1);
    });
  }

  // ————— Throttle des refresh pour éviter le clignotement —————
  function observeDrawer(section) {
    const drawer = qs(SELECTOR_DRAWER);
    if (!drawer) return;
    let tid = null;
    const mo = new MutationObserver(() => {
      clearTimeout(tid);
      tid = setTimeout(() => refresh(section), 120);
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    qsa(SELECTOR_SECTION).forEach(section => {
      if (section.dataset.__crpReady) return;
      section.dataset.__crpReady = '1';
      moveIntoDrawer(section);
      // Bind une fois le template puis premier rendu
      bindIdleTemplate(section);
      refresh(section);
      observeDrawer(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
